import React, { useState, useEffect } from 'react';
import { Segment } from 'tea-component';
import { useIntl, connect, history, useDispatch } from 'umi';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { buriedPointGame } from '@/pages/home/utils/buriedPoint';
import StreamingContext from './Page';
import { getStreamingPageLogMes } from './_config';

import '@/pages/intelligence/assets/scss/TopCharts/MobileGames/components/streaming.scss';

function Streaming(props: any) {
  const {
    gameId,
    basicInfo = {},
    isTwoMonths,
    entityType,
    tabSegment,
    activeId,
    moduleName,
    activeSegment,
    setActiveSegment,
  } = props;

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const OptionList = [
    {
      value: 'hoursWatched',
      text: formatMessage({ id: 'dbi_metric_hourswatched' }),
    },
    {
      value: 'peackCCV',
      text: formatMessage({ id: 'dbi_metric_peakccv' }),
    },
    {
      value: 'avgCCV',
      text: formatMessage({ id: 'dbi_metric_avgccv' }),
    },
    {
      value: 'airtime',
      text: formatMessage({ id: 'dbi_metric_airtime' }),
    },
  ];

  const optionsValues = OptionList?.map((item) => {
    return item.value;
  });
  // childTab 保留大小写
  const [mainSegment, setMainSegment] = useState(
    optionsValues.includes(activeSegment) ? activeSegment : optionsValues[0],
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    handlePageLog(mainSegment);
  }, []);

  // 切换选项卡
  const onTabChange = (values: string) => {
    if (!loading) {
      handlePageLog(values);
      setMainSegment(values);
      setActiveSegment(values);
      history.replace(
        `/intelligence/topCharts/${
          moduleName || 'mobileGames'
        }/gamesDetails/${gameId}/${activeId}/${values}`,
      );
      // changeStatsUrl(entityType, values, gameId, 'streaming');
    }
  };

  // 每次打点的时候，记录当前所处在的页面，包括游戏类型、一级tab和二级segment
  const recordPageMesForFeedback = (logMes: any) => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setActivedPageLogMes`,
      payload: logMes,
    });
  };
  // 打点
  const handlePageLog = (active: string) => {
    const tab = active?.toLocaleLowerCase();
    // 获取打点配置信息
    const pageLogMes = getStreamingPageLogMes(entityType, tab);

    if (gameId && pageLogMes) {
      buriedPointGame(pageLogMes, gameId);
    }
    // 每次打点的时候，记录当前打点信息用于详情页头部的feedback参数
    // 原来的recordPageRoute函数
    recordPageMesForFeedback(pageLogMes);
  };

  return (
    <div className="dbi-gamedetail-streaming">
      <Segment
        className="segment-light"
        value={mainSegment}
        onChange={(value) => onTabChange(value)}
        options={OptionList}
      />
      <StreamingContext
        {...props}
        entityType={entityType}
        loading={loading}
        setLoading={setLoading}
        mainSegment={mainSegment}
        isCalibrated={false}
        isTwoMonths={isTwoMonths}
        basicInfo={basicInfo}
        gameId={gameId}
        activeTab={tabSegment}
        key={mainSegment}
      />
    </div>
  );
}

export default connect((state: any) => {
  return {
    topchartsState: state[DBI_TOPCHARTS],
  };
})(Streaming);
